export default "__VITE_ASSET__ByMehGFs__"